import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import Coupon from 'types/Coupon';
import Plan from 'types/Plan';
import PlusLandingPageBase from 'components/LandingPages/PlusLandingPageBase';
import { UserId } from '@alltrails/shared/types/User';
import CurrencyCode from 'types/CurrencyCode';
import { getPriceTotal } from 'utils/PlanUtils';
import * as styles from './TiktokLandingPage.module.scss';

type TiktokLandingPageProps = {
  coupon?: Coupon;
  plan: Plan;
  userId?: UserId;
  currencyCode: CurrencyCode;
};

export default function TiktokLandingPage({ plan, coupon, userId, currencyCode }: TiktokLandingPageProps) {
  const languageRegionCode = useLanguageRegionCode();

  const formatter = new Intl.NumberFormat(languageRegionCode, {
    style: 'currency',
    currency: currencyCode
  });

  const discountedPricePerYear = getPriceTotal(plan, coupon);
  const monthlyCost = discountedPricePerYear / 12;

  return (
    <PlusLandingPageBase
      buttonText="Save today"
      coupon={coupon}
      headline="Exclusive TikTok Offer"
      title="Save 33% on AllTrails+"
      subhead={
        <p>
          Just <s className={styles.s}>{`${formatter.format(Number(plan.priceTotal))}`}</s>
          {` ${formatter.format(discountedPricePerYear)} for one year (that's ${formatter.format(monthlyCost)} a month)`}
        </p>
      }
      userId={userId}
      plan={plan}
    />
  );
}
